import { FluentProvider } from '@fluentui/react-components';
import { tokens } from '@fluentui/react-components';
import { TeamsFxContext } from './context/TeamsContext';
import { selectedTheme } from './styles/theme/theme';
import { ThemeProvider } from 'styled-components';
import { initializeIcons } from '@fluentui/font-icons-mdl2';
import { useInitializeTeamsApp } from './hooks/useInitializeTeamsApp';
import { AppRouter } from './routes/Router';
import { isMobile, isMobileOnly } from 'react-device-detect';
import { LoadingSpinner } from './components/common/LoadingSpinner/LoadingSpinner';
import axios from 'axios';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;

const browserHistory = createBrowserHistory();

export const reactPlugin = new ReactPlugin();
export const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: process.env.REACT_APP_ANALYTICS_ID,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});

initializeIcons();
appInsights.loadAppInsights();

export const App = () => {
  const {
    isLoading,
    teamsUserCredential,
    theme,
    themeString,
    currentUserEmail,
    appHost,
  } = useInitializeTeamsApp();
  return (
    <TeamsFxContext.Provider
      value={{
        theme,
        themeString,
        teamsUserCredential,
        isMobile,
        isMobileOnly,
        currentUserEmail,
        appHost,
      }}
    >
      <FluentProvider
        theme={selectedTheme(themeString)}
        style={{
          background: tokens.colorNeutralBackground3,
          height: '100%',
          width: '100%',
        }}
      >
        <ThemeProvider theme={selectedTheme(themeString)}>
          {!isLoading ? <AppRouter /> : <LoadingSpinner />}
        </ThemeProvider>
      </FluentProvider>
    </TeamsFxContext.Provider>
  );
};
